import { Question } from '../types';

export const mathQuestions: Question[] = [
  {
    id: 'math_001',
    subject: 'math',
    skill_dimension: 'processing_speed',
    difficulty: 1,
    question_type: 'multiple_choice',
    content: {
      title: '25 + 37 = ?',
      options: ['60', '62', '64', '66'],
      correct_answer: '62',
      explanation: '25 + 37 = 62'
    },
    scoring_weights: {
      accuracy: 0.4,
      speed: 0.6
    },
    time_limit: 15
  },
  {
    id: 'math_002',
    subject: 'math',
    skill_dimension: 'pattern_recognition',
    difficulty: 2,
    question_type: 'multiple_choice',
    content: {
      title: '找规律：2, 4, 8, 16, ?',
      options: ['24', '28', '32', '36'],
      correct_answer: '32',
      explanation: '每一项都是前一项的2倍：2×2=4, 4×2=8, 8×2=16, 16×2=32'
    },
    scoring_weights: {
      accuracy: 0.7,
      speed: 0.3
    },
    time_limit: 30
  },
  {
    id: 'math_003',
    subject: 'math',
    skill_dimension: 'abstract_thinking',
    difficulty: 3,
    question_type: 'multiple_choice',
    content: {
      title: '如果 a + b = 10，a - b = 4，那么 a × b = ?',
      options: ['21', '24', '25', '28'],
      correct_answer: '21',
      explanation: '解方程组：a=7, b=3，所以 a×b=21'
    },
    scoring_weights: {
      accuracy: 0.8,
      speed: 0.2
    },
    time_limit: 60
  },
  {
    id: 'math_004',
    subject: 'math',
    skill_dimension: 'working_memory',
    difficulty: 2,
    question_type: 'multiple_choice',
    content: {
      title: '计算：(15 + 8) × 3 - 17 = ?',
      options: ['52', '54', '56', '58'],
      correct_answer: '52',
      explanation: '按运算顺序：(15+8)×3-17 = 23×3-17 = 69-17 = 52'
    },
    scoring_weights: {
      accuracy: 0.6,
      speed: 0.4
    },
    time_limit: 45
  },
  {
    id: 'math_005',
    subject: 'math',
    skill_dimension: 'transfer_application',
    difficulty: 3,
    question_type: 'multiple_choice',
    content: {
      title: '小明买3支笔花了12元，同样的笔买7支需要多少元？',
      options: ['24元', '26元', '28元', '30元'],
      correct_answer: '28元',
      explanation: '每支笔12÷3=4元，7支笔需要4×7=28元'
    },
    scoring_weights: {
      accuracy: 0.7,
      speed: 0.3
    },
    time_limit: 60
  }
];

export const chineseQuestions: Question[] = [
  {
    id: 'chinese_001',
    subject: 'chinese',
    skill_dimension: 'processing_speed',
    difficulty: 1,
    question_type: 'multiple_choice',
    content: {
      title: '下列词语中哪个是错误的？',
      options: ['美丽', '漂亮', '美里', '好看'],
      correct_answer: '美里',
      explanation: '正确写法应该是"美丽"，不是"美里"'
    },
    scoring_weights: {
      accuracy: 0.5,
      speed: 0.5
    },
    time_limit: 10
  },
  {
    id: 'chinese_002',
    subject: 'chinese',
    skill_dimension: 'pattern_recognition',
    difficulty: 2,
    question_type: 'multiple_choice',
    content: {
      title: '"春眠不觉晓"的下一句是？',
      options: ['处处闻啼鸟', '夜来风雨声', '花落知多少', '举头望明月'],
      correct_answer: '处处闻啼鸟',
      explanation: '这是孟浩然《春晓》中的诗句'
    },
    scoring_weights: {
      accuracy: 0.8,
      speed: 0.2
    },
    time_limit: 20
  },
  {
    id: 'chinese_003',
    subject: 'chinese',
    skill_dimension: 'abstract_thinking',
    difficulty: 3,
    question_type: 'multiple_choice',
    content: {
      title: '"望梅止渴"这个成语主要说明了什么道理？',
      options: ['梅子很甜', '想象可以产生真实感受', '要多吃水果', '夏天很热'],
      correct_answer: '想象可以产生真实感受',
      explanation: '这个成语说明心理暗示和想象力的作用'
    },
    scoring_weights: {
      accuracy: 0.9,
      speed: 0.1
    },
    time_limit: 45
  },
  {
    id: 'chinese_004',
    subject: 'chinese',
    skill_dimension: 'working_memory',
    difficulty: 2,
    question_type: 'multiple_choice',
    content: {
      title: '下面句子的正确语序是？\n词汇：小猫、在、花园里、追逐、蝴蝶',
      options: [
        '小猫追逐蝴蝶在花园里',
        '在花园里小猫追逐蝴蝶',
        '小猫在花园里追逐蝴蝶',
        '追逐蝴蝶小猫在花园里'
      ],
      correct_answer: '小猫在花园里追逐蝴蝶',
      explanation: '正确的语序应该是：主语+地点状语+谓语+宾语'
    },
    scoring_weights: {
      accuracy: 0.7,
      speed: 0.3
    },
    time_limit: 30
  },
  {
    id: 'chinese_005',
    subject: 'chinese',
    skill_dimension: 'transfer_application',
    difficulty: 3,
    question_type: 'multiple_choice',
    content: {
      title: '如果要向外国朋友介绍中国的传统节日，最应该强调什么？',
      options: ['节日的时间', '节日的文化内涵和意义', '节日的食物', '节日的装饰'],
      correct_answer: '节日的文化内涵和意义',
      explanation: '文化交流中最重要的是传达文化的深层含义和价值观'
    },
    scoring_weights: {
      accuracy: 0.8,
      speed: 0.2
    },
    time_limit: 60
  }
];

export const allQuestions = [...mathQuestions, ...chineseQuestions];